import React, { useState } from 'react'

import getCookie from 'utils/getCookie'
import { requestUserLogout } from 'api/user'

export const AuthContext = React.createContext(false)

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(getCookie('jwtfe'))

  const logout = () => {
    requestUserLogout()
    setIsAuthenticated(false)
    document.cookie = "jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict"
    document.cookie = "jwtfe=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict" 
  }

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, setIsAuthenticated, logout }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
